(function () {
  function initTimelineSection(root = document) {
    root.querySelectorAll('[data-timeline-section]').forEach((section) => {
      if (section.dataset.timelineInit === 'true') return

      const mediaItems = section.querySelectorAll('[data-timeline-media-item]')
      const contentItems = section.querySelectorAll('[data-timeline-content-item]')
      const stepItems = section.querySelectorAll('[data-timeline-step]')
      const prevButton = section.querySelector('[data-timeline-prev]')
      const nextButton = section.querySelector('[data-timeline-next]')
      const dotItems = section.querySelectorAll('.timeline-section__dot')

      if (!mediaItems.length || !contentItems.length || !stepItems.length || !prevButton || !nextButton) return

      const lastIndex = mediaItems.length - 1
      let activeIndex = 0

      const pauseAllVideos = () => {
        section.querySelectorAll('video').forEach((video) => {
          video.pause()
        })
      }

      const playActiveVideo = () => {
        const activeVideo = mediaItems[activeIndex]?.querySelector('video')
        if (!activeVideo) return

        activeVideo.defaultMuted = true
        activeVideo.muted = true
        activeVideo.loop = true
        activeVideo.autoplay = true
        activeVideo.playsInline = true
        activeVideo.setAttribute('muted', '')
        activeVideo.setAttribute('loop', '')
        activeVideo.setAttribute('autoplay', '')
        activeVideo.setAttribute('playsinline', '')

        const playPromise = activeVideo.play()
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {
          })
        }
      }

      const setActiveStep = (index) => {
        activeIndex = Math.max(0, Math.min(index, lastIndex))

        mediaItems.forEach((item, itemIndex) => {
          const isActive = itemIndex === activeIndex
          item.classList.toggle('is-active', isActive)
          item.hidden = !isActive
        })

        contentItems.forEach((item, itemIndex) => {
          const isActive = itemIndex === activeIndex
          item.classList.toggle('is-active', isActive)
          item.hidden = !isActive
        })

        stepItems.forEach((step, stepIndex) => {
          step.classList.toggle('is-active', stepIndex === activeIndex)
        })

        prevButton.disabled = activeIndex === 0
        nextButton.disabled = activeIndex === lastIndex

        pauseAllVideos()
        playActiveVideo()
      }

      prevButton.addEventListener('click', () => {
        setActiveStep(activeIndex - 1)
      })

      nextButton.addEventListener('click', () => {
        setActiveStep(activeIndex + 1)
      })

      // 點擊 dot 時切換到對應 step
      dotItems.forEach((dot, idx) => {
        dot.addEventListener('click', () => {
          setActiveStep(idx)
        })
      })

      setActiveStep(0)
      section.dataset.timelineInit = 'true'
    })
  }

  document.addEventListener('DOMContentLoaded', () => {
    initTimelineSection()
  })

  document.addEventListener('shopify:section:load', (event) => {
    initTimelineSection(event.target)
  })
})()
